import { useState } from 'react';
import { useQuery } from 'react-query';
import { Table } from 'ant-table-extensions';
import { Card } from "antd";
import useHttpClient from '../../../shared/sendRequest/useHttpClient';
import { useAuthContext } from '../../../shared/context/auth-context';
import './myTable.css';

export default function MyTable({ columns, style, endPoint }) {
    const DEFAULT_PAGESIZE = 5
    const DEFAULT_CURRENT = 1
    const [pagination, setPagination] = useState({ current: DEFAULT_CURRENT, pageSize: DEFAULT_PAGESIZE,pageSizeOptions:[5],showSizeChanger:false,responsive:true });
    const { sendRequest } = useHttpClient();
    const { ContractId } = useAuthContext()

    const { data, isLoading } = useQuery(['fetchTrips', pagination], () =>
        sendRequest({
            endpoint: endPoint?.concat(`?items=${pagination.pageSize}&page=${pagination.current}&ContractId=${ContractId}`),
            method: 'GET',
        }),
        { onSuccess: (onSuccessData) => setPagination({ ...pagination, current: onSuccessData?.pageIndex, total: onSuccessData?.totalCount }) }
    )

    const handleTableChange = (filters) => {
        setPagination({ ...pagination, current: filters.current, pageSize: filters.pageSize })
    }


    return (
        <Card type="inner">
            <Table                
                dataSource={data?.items}
                searchable={false}
                rowClassName={(item) => item?.isActive === "0" && 'table-row-red'}
                loading={isLoading}
                columns={columns}
                pagination={pagination}
                style={style}
                onChange={handleTableChange}
            />
        </Card>
    )
}